import { useEffect } from 'react';
import sysend from 'sysend';

// hook to listen to sysend broadcast events and trigger a handler
const useSysendBroadcastListener = (broadcastEvent, broadcastHandler) => {
  useEffect(() => {
    sysend.on(broadcastEvent, broadcastHandler);

    return () => {
      sysend.off(broadcastEvent);
    };
  }, []);
};

export default useSysendBroadcastListener;
